// Sentry browser SDK init — loaded by instrumentation-client.ts.
// DSN-gated: without NEXT_PUBLIC_SENTRY_DSN nothing is imported or initialised,
// so deployments without Sentry pay no bundle cost.
// openspec: iso27001-soc2-readiness task 1.4
// Follow-up: wrap next.config.js with withSentryConfig for source-map upload
// and automatic router instrumentation (owned by the next.config.js change).

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN

/**
 * Known non-actionable browser / engine noise.
 * EmptyRanges: WebKit NullMedia.buffered/played/seekable bug (webkit#318284)
 * that surfaces on iOS when a media controller outlives its <video> (STYTRIX-WEB-A).
 */
const IGNORED_ERRORS: Array<string | RegExp> = [
  "Can't find variable: EmptyRanges",
  /Can't find variable:\s*EmptyRanges/,
  'ReferenceError: EmptyRanges',
]

function isEmptyRangesNoise(message: unknown): boolean {
  return typeof message === 'string' && message.includes('EmptyRanges')
}

export function initSentryClient(): void {
  if (!dsn || typeof window === 'undefined') return
  import('@sentry/nextjs')
    .then((Sentry) => {
      Sentry.init({
        dsn,
        tracesSampleRate: 0.05,
        sendDefaultPii: false,
        environment: process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV || 'development',
        ignoreErrors: IGNORED_ERRORS,
        beforeSend(event, hint) {
          const message =
            event.message ||
            event.exception?.values?.[0]?.value ||
            (hint?.originalException as Error | undefined)?.message ||
            ''
          if (isEmptyRangesNoise(message)) return null
          return event
        },
      })
    })
    .catch((err) => {
      console.warn('[sentry] client init skipped:', (err as Error)?.message)
    })
}
